/**
 * @generated SignedSource<<e89d02b9a20fcaff4cda1b4ccb9afdcb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type designCard_versionIssueAssociatedDesigns_jiraVersion$data = {
  readonly id: string;
  readonly " $fragmentType": "designCard_versionIssueAssociatedDesigns_jiraVersion";
};
export type designCard_versionIssueAssociatedDesigns_jiraVersion$key = {
  readonly " $data"?: designCard_versionIssueAssociatedDesigns_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"designCard_versionIssueAssociatedDesigns_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "designCard_versionIssueAssociatedDesigns_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "574075efd4cf2b2db85cdf409e87e841";

export default node;
